<!-- =========================================================================================
  File Name: list.vue
  Description: Notification List
========================================================================================== -->

<template>
  <div id="notification-list">

    <vx-card title="风控通知列表">

      <vs-table stripe :data="list" noDataText="暂无通知">
        <template slot="thead">
          <vs-th width="80">ID</vs-th>
          <vs-th width="120">标题</vs-th>
          <vs-th width="300">内容</vs-th>
          <vs-th width="150">会员账号</vs-th>
          <vs-th width="150">时间</vs-th>
          <vs-th width="150">操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.id}}</vs-td>
            <vs-td :data="item.title">{{item.title}}</vs-td>
            <vs-td :data="item.content">{{item.content}}: {{item.sameValue}}</vs-td>
            <vs-td :data="item.idList">{{item.idList}}</vs-td>
            <vs-td :data="item.date">{{item.date}}</vs-td>
            <vs-td>
              <vs-button v-if="item.isRead == 0" color="primary" type="filled" size="small" @click="read" :data-index="index" class="ml-4">已读</vs-button>
              <vs-button color="danger" type="border" size="small" @click="del" :data-index="index" class="ml-4">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>
  </div>
</template>

<script>

export default {
  data() {
    return {
      keyword: '',
      page: 1,
      totalPage: 1,
      list: []
    }
  },
  methods: {
    del (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.id = this.list[index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该通知吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('notification-delete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list.splice(index, 1)
          })
        }
      })
    },
    read (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.id = this.list[index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认已读吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('notification-read', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list[index].isRead = 1
          })
        }
      })
    },
    search() {
      this.page = 1
      this.load()
    },
    load() {
      this.$utils.post('notification-list', { authKey: localStorage.getItem('authKey'), page: this.page }).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  mounted () {
    this.load()
  }
}
</script>

<style>
  .ql-tooltip {
    left: 0 !important;
  }
</style>
